/**
 * # swDateValidator
 * Validates dates to be valid and before or after a certain date
 *
 * ## Usage example
 * <pre>
 *   <input type="date" sw-date-validator before="dateSource.now()" after="dateSource.now()"></button>
 * </pre>
 */
angular
  .module('coreModule')
  // TODO find out better name for that
  .directive('swDateValidator', ($parse: ng.IParseService, moment) => ({
    restrict: 'A',
    require: 'ngModel',
    priority: 10,
    link: function postLink(scope, element, attrs, ngModel) {
      const before = $parse(attrs.before)(scope);
      const after = $parse(attrs.after)(scope);

      //For DOM -> model validation
      ngModel.$parsers.unshift((value) => {
        let valid = true;
        if (!value || !moment(value, 'DD-MM-YYYY').isValid()) {
          ngModel.$setValidity('date', false);
          valid = false;
        } else {
          ngModel.$setValidity('date', true);
        }

        if (before) {
          if (moment(value, 'DD-MM-YYYY').isBefore(before)) {
            ngModel.$setValidity('pastDate', false);
            valid = false;
          } else {
            ngModel.$setValidity('pastDate', true);
          }
        }

        if (after) {
          if (moment(value, 'DD-MM-YYYY').isAfter(after)) {
            ngModel.$setValidity('futureDate', false);
            valid = false;
          } else {
            ngModel.$setValidity('futureDate', true);
          }
        }

        return valid ? value : undefined;
      });
    },
  }));
